<template>
  <div class="rotatoscope-container">
    <div class="rotatoscope-content" ref="content">

      <slot></slot>
      <div class="axes">
        <div class="x-axis"></div>
        <div class="y-axis"></div>
        <div class="z-axis"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { startLoop } from './common.js';

export default {
  data() {
    return {
      stopLoop: null
    };
  },
  mounted() {
    const content = this.$refs.content;

    this.stopLoop = startLoop((t, dt) => {
      content.style = `
        transform: rotateY(${Math.sin(t/1000)*180}deg);
      `;
    });
    
  }
}
</script>

<style lang="scss">
.rotatoscope-container {
  position: relative;
  transform-style: preserve-3d;
}
.rotatoscope-content {
  transform-origin: center;
  transform-style: preserve-3d;
}

.axes {
  position: absolute;
  left: 50%;
  bottom: 50%;
  width: 100px;
  height: 100px;
  transform-style: preserve-3d;
}

.axis {
  transform-style: preserve-3d;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100px;
  height: 2px;
  border-radius: 1px;
  transform-origin: bottom left;
}

.x-axis {
  @extend .axis;
  background-color: red;
}

.y-axis {
  @extend .axis;
  background-color: green;
  transform: rotateZ(-90deg);
}

.z-axis {
  @extend .axis;
  background-color: blue;
  transform: rotateY(-90deg);
}
</style>



// WEBPACK FOOTER //
// rotatoscope.vue?da8b9a30